import { useMutation, useQueryClient } from '@tanstack/react-query';

import useCredentials from 'api/hook/useCredentials';
import { baseAxios, handleError } from 'api';

export function useDeletePolicy(invoiceId) {
  const authAxios = useCredentials();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      baseAxios(authAxios, {
        url: '/policy',
        method: 'delete',
        data,
      }),
    onError: handleError,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['order', invoiceId] });
    },
  });
}
